<template>
    <div>
        <div class="card">
            <div class="card-header">Team settings</div>
            <div class="card-body">
                <div v-if="loading" class="text-center">
                    <b-spinner></b-spinner>
                </div>
                <div v-else>
                    <validation-observer ref="observer" v-slot="{ passes }">
                        <b-form @submit.stop.prevent="passes(saveSettings)">


                            <b-form-group id="ai_styleFormGroup" label="AI Writing Tone" label-for="ai_styleSelect">
                                <validation-provider name="AI Writing Tone" rules="required" v-slot="{ errors }">
                                    <b-form-select id="ai_styleSelect" v-model="team.ai_style">

                                        <option v-for="tone in ai_tones" :key="tone.key" :value="tone.key">{{ ucFirst(tone.name) }}</option>

                                    </b-form-select>
                                    <span class="validation">{{ errors[0] }}</span>
                                </validation-provider>
                                <p>{{ selectedToneDescription }}</p>
                            </b-form-group>

                            <b-button type="submit" variant="primary">Save</b-button>
                        </b-form>
                    </validation-observer>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import NotificationPop
    from "../mixins/NotificationPop";

export default {
    mixins: [NotificationPop],
    computed: {
        selectedToneDescription() {
            const selectedTone = this.ai_tones.find(tone => tone.name === this.team.ai_style);
            return selectedTone ? selectedTone.description : '';
        }
    },
    data() {
        return {
            team: {
                from_name: '',
                ai_style: '',
            },
            "ai_tones": [
                {
                    "name": "😊 Appreciative",
                    "description": "Expresses gratitude, thanks, or appreciation towards the recipient.",
                    "key": "appreciative"
                },
                {
                    "name": "👍 Assertive",
                    "description": "Confident, direct, and to the point. Used for expressing strong opinions or making firm requests.",
                    "key": "assertive"
                },
                {
                    "name": "🎯 Authoritative",
                    "description": "Confident, commanding, and assertive. Establishes authority or expertise on a subject.",
                    "key": "authoritative"
                },
                {
                    "name": "🤝 Conciliatory",
                    "description": "Diplomatic, cooperative, and seeks to find common ground or resolve conflicts.",
                    "key": "conciliatory"
                },
                {
                    "name": "❓ Curious",
                    "description": "Inquisitive and exploratory. Asks questions or seeks information to encourage a dialogue.",
                    "key": "curious"
                },
                {
                    "name": "❤️ Empathetic",
                    "description": "Demonstrates understanding, empathy, and sensitivity towards the recipient's situation or concerns.",
                    "key": "empathetic"
                },
                {
                    "name": "💥 Energetic",
                    "description": "Vibrant, lively, and full of enthusiasm. Creates an energetic and dynamic tone.",
                    "key": "energetic"
                },
                {
                    "name": "🌟 Friendly",
                    "description": "Warm, conversational, and casual. Suitable for informal communication or maintaining a friendly tone.",
                    "key": "friendly"
                },
                {
                    "name": "😄 Humorous",
                    "description": "Incorporates humor, wit, or light-heartedness to create an engaging and entertaining email.",
                    "key": "humorous"
                },
                {
                    "name": "ℹ️ Informative",
                    "description": "Focuses on providing clear and concise information. Suitable for instructional or educational emails.",
                    "key": "informative"
                },
                {
                    "name": "🌈 Inspirational",
                    "description": "Motivational and uplifting. Includes encouraging words or positive affirmations to inspire action.",
                    "key": "inspirational"
                },
                {
                    "name": "🔍 Objective",
                    "description": "Neutral, unbiased, and focuses on presenting facts or information without personal opinion.",
                    "key": "objective"
                },
                {
                    "name": "💪 Persuasive",
                    "description": "Convincing and influential. Utilizes compelling language to persuade the reader.",
                    "key": "persuasive"
                },
                {
                    "name": "💼 Professional",
                    "description": "Formal, polite, and suitable for business-related emails or professional communication.",
                    "key": "professional"
                },
                {
                    "name": "🤗 Supportive",
                    "description": "Compassionate, encouraging, and helpful. Provides support, reassurance, or guidance to the recipient.",
                    "key": "supportive"
                },
                {
                    "name": "🤔 Thoughtful",
                    "description": "Considerate, introspective, and carefully reflects on the topic or subject matter.",
                    "key": "thoughtful"
                },
                {
                    "name": "⏰ Urgent",
                    "description": "Conveys a sense of urgency or importance. Used for time-sensitive matters or immediate action.",
                    "key": "urgent"
                }
            ],



            loading: true
        };
    },
    created() {
        // Fetch team data from API
        this.$http.get(`team/settings`)
            .then(response => {
                this.team = response.data.data;
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                // Hide the loading spinner
                this.loading = false;
            });
    },
    methods: {
        ucFirst(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        saveSettings() {

            this.$http
                .post('team/settings', this.team)
                .then(response => {
                    this.popNotification('Settings saved successfully', 'success')
                    console.log('Settings saved successfully');
                })
                .catch(error => {
                    this.popNotification('Cannot save settings. Please contact support', 'danger')
                    console.error('Error saving settings', error);
                });
        },
    },
};
</script>

<style scoped>
.b-form-group {
    margin-bottom: 1rem;
}
</style>
